import React, { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import styles from './Setup.scss';
import EmployeePopUp from './EmployeePopUp';
import { useTranslation } from 'react-i18next';
import { HeadOffice, Employee, FbData, Dependent, Pulldown, ArrowBold } from 'jbc-front/components/icons';
import { Section } from 'jbc-front/components/Form';
import Joyride from 'react-joyride';
import { connect } from 'react-redux';
import { redirectTo } from 'src/utils/Http';
import { getItem, setItem } from 'src/reducers/common/itemReducer';
// import stepStatus from 'src/reducers/guideTour';
import { getCurrentUserInfo } from 'src/reducers/users/currentUser';

const Setup = ({ notCompletedSetting, dispatch, stepIndex, run, step, currentUser }) => {
  const { t, i18n } = useTranslation();
  const STEPS = [
    {
      url: '/clients/edit',
      type: 'client_info',
      description: (
        <dl className={styles.setup}>
          <dt className={styles.setupTitle}>{t('features.Dashbord.components.Setup.register_office')}</dt>
          <dd className={styles.setupText}>{t('features.Dashbord.components.Setup.input_office_name_and_address')}</dd>
          <dd className={styles.setupText}>{t('features.Dashbord.components.Setup.check_client_tax_income')}</dd>
        </dl>
      ),
      icon: <HeadOffice size={35} />
    },
    {
      url: '/clients/payroll_rules_groups',
      type: 'payroll_rules_groups',
      description: (
        <dl className={styles.setup}>
          <dt className={styles.setupTitle}>{t('features.Dashbord.components.Setup.salary_rules_setting')}</dt>
          <dd className={styles.setupText}>
            <p>{t('features.Dashbord.components.Setup.1_create_group_salary_rules')}</p>
            <p>{t('features.Dashbord.components.Setup.2_create_provision_and_deduction_items')}</p>
            <p>{t('features.Dashbord.components.Setup.3_create_unit_price_such_as_unit_price_per_one_hour')}</p>
            <p>{t('features.Dashbord.components.Setup.4_repeat_step_1_to_3_to_create_rules_for_multiple_groups')}</p>
          </dd>
        </dl>
      ),
      icon: <FbData size={35} />
    },
    {
      url: '/employees',
      type: 'employees',
      description: (
        <dl className={styles.setup}>
          <dt className={styles.setupTitle}>{t('features.Dashbord.components.Setup.employee_setting')}</dt>
          <dd className={styles.setupText}>
            <p>{t('features.Dashbord.components.Setup.register_new_employee')}</p>
            <div>
              {t('features.Dashbord.components.Setup.information_required_for_payroll')}
              <span>
                <EmployeePopUp />
              </span>
            </div>
          </dd>
        </dl>
      ),
      icon: <Employee size={35} />
    }
  ];

  if (isEmpty(notCompletedSetting)) {
    return null;
  }
  return (
    <div className={styles.setups}>
      <div className="l-flex-xl u-pc-pt50 u-sp-pt20">
        <Section title={t('features.Dashbord.components.Setup.complete_initial_setup')} className={styles.section}>
          <div className={styles.listContainer}>
            {STEPS.filter(item => notCompletedSetting.includes(item.type))
              .map((step, index) => (
                <div id={step.type} className={`${styles.item} ${index != 0 ? styles.disabled : ''}`} key={step.type} onClick={() => redirectTo(step.url)}>
                  <div className={styles.icon}>{step.icon}</div>
                  {step.description}
                  <div className={styles.arrow}>
                    <Pulldown size={10} />
                  </div>
                </div>
              ))
              .reduce(
                (prev, curr) => [
                  prev,
                  <div className={styles.next} key={curr.type}>
                    <ArrowBold size={15} />
                  </div>,
                  curr
                ],
                []
              )}
          </div>
        </Section>
      </div>
    </div>
  );
};
const mapStateToProps = state => ({
  stepIndex: state.guideTour.stepIndex,
  run: state.guideTour.run,
  step: state.guideTour.step,

  currentUser: getCurrentUserInfo(state)
});
export default connect(mapStateToProps)(Setup);
